module.exports = __webpack_public_path__ + "assets/img/new-2.f1f8a141.png";